"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _QuickLRU = _interopRequireDefault(require("../util/QuickLRU"));

var _configuration = require("../configuration");

/*  text-searching controller */
var TextSearchManager = /*#__PURE__*/function () {
  function TextSearchManager(pluginManager) {
    (0, _classCallCheck2.default)(this, TextSearchManager);
    (0, _defineProperty2.default)(this, "adapterCache", void 0);
    (0, _defineProperty2.default)(this, "pluginManager", void 0);
    this.pluginManager = pluginManager;
    this.adapterCache = new _QuickLRU.default({
      maxSize: 15
    });
  }
  /**
   * Instantiate/initialize list of relevant adapters
   */


  (0, _createClass2.default)(TextSearchManager, [{
    key: "loadTextSearchAdapters",
    value: function loadTextSearchAdapters(searchScope) {
      var _this = this;

      return this.relevantAdapters(searchScope).map(function (adapterConfig) {
        var adapterId = (0, _configuration.readConfObject)(adapterConfig, 'textSearchAdapterId');

        if (_this.adapterCache.has(adapterId)) {
          return _this.adapterCache.get(adapterId);
        } else {
          var _this$pluginManager$g = _this.pluginManager.getTextSearchAdapterType(adapterConfig.type),
              AdapterClass = _this$pluginManager$g.AdapterClass;

          var adapter = new AdapterClass(adapterConfig, undefined, _this.pluginManager);

          _this.adapterCache.set(adapterId, adapter);

          return adapter;
        }
      });
    }
    /**
     * Returns list of relevant text search adapters to use
     * @param args - search options/arguments include: search query
     */

  }, {
    key: "relevantAdapters",
    value: function relevantAdapters(searchScope) {
      var _this$pluginManager$r;

      var _ref = (_this$pluginManager$r = this.pluginManager.rootModel) === null || _this$pluginManager$r === void 0 ? void 0 : _this$pluginManager$r.jbrowse,
          aggregateTextSearchAdapters = _ref.aggregateTextSearchAdapters,
          tracks = _ref.tracks;

      var assemblyName = searchScope.assemblyName;
      return [].concat((0, _toConsumableArray2.default)(this.getAdaptersWithAssembly(assemblyName, aggregateTextSearchAdapters)), (0, _toConsumableArray2.default)(this.getAdaptersWithAssembly(assemblyName, tracks.map(function (track) {
        return (0, _configuration.readConfObject)(track, ['textSearching', 'textSearchAdapter']);
      }))));
    }
  }, {
    key: "getAdaptersWithAssembly",
    value: function getAdaptersWithAssembly(asmName, adapterConfs) {
      return adapterConfs.filter(function (conf) {
        var _readConfObject;

        return (_readConfObject = (0, _configuration.readConfObject)(conf, 'assemblyNames')) === null || _readConfObject === void 0 ? void 0 : _readConfObject.includes(asmName);
      });
    }
    /**
     * Returns list of relevant results given a search query and options
     * @param args - search options/arguments include: search query
     * limit of results to return, searchType...prefix | full | exact", etc.
     */

  }, {
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(args, searchScope, rankFn) {
        var textSearchAdapters, results;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // determine list of relevant adapters based on scope
                textSearchAdapters = this.loadTextSearchAdapters(searchScope);
                _context.next = 3;
                return Promise.all(textSearchAdapters.map(function (adapter) {
                  return adapter.searchIndex(args);
                }));

              case 3:
                results = _context.sent;
                return _context.abrupt("return", this.sortResults(results.flat(), rankFn));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function search(_x, _x2, _x3) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
    /**
     * Returns array of revelevant and sorted results
     * @param results - array of results from all text search adapters
     * @param rankFn - function that updates results scores
     * based on more relevance
     */

  }, {
    key: "sortResults",
    value: function sortResults(results, rankFn) {
      return rankFn(results.sort(function (a, b) {
        return -b.getLabel().localeCompare(a.getLabel());
      })).sort(function (result1, result2) {
        return result1.getScore() - result2.getScore();
      });
    }
  }]);
  return TextSearchManager;
}();

exports.default = TextSearchManager;